module.exports = __webpack_public_path__ + "static/media/decentralize_1.df5fb588.svg";